import { base } from './base.styles';
import { typography } from './typography.styles';

export const styles = {
    base,
    typography,
};
